import axios from 'axios';
const sanitizeBaseURL = (url: string) => url.replace(/\/$/, '');

if (!process.env.NEXT_PUBLIC_DOMAIN) {
  throw new Error('NEXT_PUBLIC_DOMAIN is not defined');
}

export const mrAPIV3 = axios.create({
  baseURL: `${
    process.env.NEXT_PUBLIC_DATA_API_V3 || 'https://api.maisretorno.com/v3'
  }`,
  headers: { Referer: process.env.NEXT_PUBLIC_DOMAIN },
});

export const apiGatewayAPI = axios.create({
  headers: { 'Content-Type': 'application/json' },
  baseURL: `${
    process.env.NEXT_PUBLIC_API_GATEWAY_API ||
    'https://data.maisretorno.com/api/v3'
  }`,
});

export const strapiAPI = axios.create({
  baseURL: `${
    process.env.NEXT_PUBLIC_STRAPI_API || 'https://portal.maisretorno.com/api'
  }`,
});

export const fakeAPI = axios.create({
  baseURL: 'http://localhost:3333',
});

export const axiosUserDataAPI = axios.create({
  baseURL: sanitizeBaseURL(
    process.env.NEXT_PUBLIC_BFF_API_URL ||
      process.env.NEXT_PUBLIC_NEST_API ||
      'https://userdata.maisretorno.com'
  ),
});

export const axiosPortalInstance = axios.create({
  baseURL: 'https://portal.maisretorno.com',
});
